module.exports = function ImageHandler(src, option, bypass = false) {
  if (src) {
    //const imageService = '//img2.storyblok.com/';
    let imageService = 'https://gallant-borg-bf9d98.netlify.app/images/';
    if (bypass === true) {
      imageService = 'https://gallant-borg-bf9d98.netlify.app/static/';
    }

    const path = src.replace('https://a.storyblok.com', '');

    let size;
    if (!option) {
      size = `1920x1080`;
    } else {
      size = option;
    }

    return imageService + size + path;
  } else {
    return null;
  }
};
